var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCondensedPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 376.98 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e8b68549-ce0f-48e8-8b98-0194c3a1db91",
    x1: 188.49,
    x2: 188.49,
    y2: 211.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5365c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba54f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb30548e-675f-4af3-885c-21b9cca6376b",
    x1: 23.19,
    y1: 215.75,
    x2: 23.19,
    y2: 280.27,
    xlinkHref: "#e8b68549-ce0f-48e8-8b98-0194c3a1db91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9a4cd07-2759-48ee-ab87-f1f53ca53175",
    x1: 65.97,
    y1: 215.75,
    x2: 65.97,
    y2: 280.27,
    xlinkHref: "#e8b68549-ce0f-48e8-8b98-0194c3a1db91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b5b2a0f3-bf4c-4c4d-a90e-d28176acf1d7",
    x1: 107.29,
    y1: 215.75,
    x2: 107.29,
    y2: 280.27,
    xlinkHref: "#e8b68549-ce0f-48e8-8b98-0194c3a1db91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e6f9d23c-d78f-4458-b95e-5a2a052b0056",
    x1: 310.41,
    y1: 215.75,
    x2: 310.41,
    y2: 280.27,
    xlinkHref: "#e8b68549-ce0f-48e8-8b98-0194c3a1db91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2739081-bd65-45c2-8df7-58016a31d40e",
    x1: 148.13,
    y1: 215.75,
    x2: 148.13,
    y2: 280.27,
    xlinkHref: "#e8b68549-ce0f-48e8-8b98-0194c3a1db91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac2c2bab-c9ba-4364-836a-dba0380f4d29",
    x1: 273.37,
    y1: 215.75,
    x2: 273.37,
    y2: 280.27,
    xlinkHref: "#e8b68549-ce0f-48e8-8b98-0194c3a1db91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb6c5106-8b30-4cd3-8ea1-47fbdbb31dee",
    x1: 350.48,
    y1: 215.75,
    x2: 350.48,
    y2: 280.27,
    xlinkHref: "#e8b68549-ce0f-48e8-8b98-0194c3a1db91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f7f76f57-e85e-4e7c-a65b-2d9205365823",
    x1: 214.25,
    y1: 222.57,
    x2: 214.25,
    y2: 302.57,
    xlinkHref: "#e8b68549-ce0f-48e8-8b98-0194c3a1db91"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "condensed-pink") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "fb988471-cfa0-4ea7-a91b-1453865c4abe",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a383c145-147d-4abf-9efb-cba03d26a835",
    "data-name": "para-exports"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fbe3b2e6-2d6c-4cb8-85ed-858f977e3a7b",
    "data-name": "condensed-pink"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.55,111.16a68.32,68.32,0,0,0-33.1,72.9H204.51v27.27H8.51A101.92,101.92,0,0,1,.9,184.06,103.9,103.9,0,0,1,0,170.43,102.3,102.3,0,0,1,72.55,72.55a102.27,102.27,0,0,1,200.13,29.71v49.61l67.61-67.6L362,106l-52.61,52.61,27.55,27.55a57.32,57.32,0,0,0,6-25.58q0-1.89-.12-3.75l28.4-28.41a91.87,91.87,0,0,1-9.54,83H318.75l-31.07-31.07L272.8,195.13l-.12-.12v16.32H238.6V102.26a68.17,68.17,0,1,0-130.7,27.2L82.64,154.72A101.72,101.72,0,0,1,68.55,111.16Z",
    style: {
      fill: "url(#e8b68549-ce0f-48e8-8b98-0194c3a1db91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25,287.7V237H0v63H46.38V287.7Z",
    style: {
      fill: "url(#bb30548e-675f-4af3-885c-21b9cca6376b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,237H61.25L39.18,287.7,33.83,300H46.38l5.7-14.42H79.42L85.29,300H98.11Zm-15,39,9.88-25.64L75.5,276Z",
    style: {
      fill: "url(#a9a4cd07-2759-48ee-ab87-f1f53ca53175)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.19,237v63h12.2V237Z",
    style: {
      fill: "url(#b5b2a0f3-bf4c-4c4d-a90e-d28176acf1d7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.31,237v63h12.21V237Z",
    style: {
      fill: "url(#e6f9d23c-d78f-4458-b95e-5a2a052b0056)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.79,237v46.82h-.18L134.08,237H119.21v63h12.26V253l30.29,47h15.3V237Z",
    style: {
      fill: "url(#b2739081-bd65-45c2-8df7-58016a31d40e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.44,237v10.14h18.77V300H279.5V247.11h18.8V237Z",
    style: {
      fill: "url(#ac2c2bab-c9ba-4364-836a-dba0380f4d29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.83,280.66A34.77,34.77,0,0,1,371,300H354.65l-11.83-11.83-5.66,5.66-.05-.05V300h-13V237.18h13v40.18l25.75-25.75,8.26,8.26-20,20,10.49,10.49a21.82,21.82,0,0,0,2.28-9.74c0-.48,0-1-.05-1.43l10.82-10.82A34.8,34.8,0,0,1,376.83,280.66Z",
    style: {
      fill: "url(#bb6c5106-8b30-4cd3-8ea1-47fbdbb31dee)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.25,237a31.41,31.41,0,1,0,31.4,31.41A31.41,31.41,0,0,0,214.25,237Zm0,50.3a18.9,18.9,0,1,1,18.89-18.89A18.9,18.9,0,0,1,214.25,287.27Z",
    style: {
      fill: "url(#f7f76f57-e85e-4e7c-a65b-2d9205365823)"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondensedPink);
export default __webpack_public_path__ + "static/media/condensed-pink.e46c6a1097e1a3a63d2c0eed32c82545.svg";
export { ForwardRef as ReactComponent };